import { render, staticRenderFns } from "./SaleEditRowExtraFields.vue?vue&type=template&id=fe7e65da&scoped=true"
import script from "./SaleEditRowExtraFields.vue?vue&type=script&lang=ts"
export * from "./SaleEditRowExtraFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7e65da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe7e65da')) {
      api.createRecord('fe7e65da', component.options)
    } else {
      api.reload('fe7e65da', component.options)
    }
    module.hot.accept("./SaleEditRowExtraFields.vue?vue&type=template&id=fe7e65da&scoped=true", function () {
      api.rerender('fe7e65da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditRowExtraFields.vue"
export default component.exports